import React from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import EventList from './pages/EventList';
import EventDetail from './pages/EventDetail';
import CreateEvent from './pages/CreateEvent';
import EventRSVPList from './pages/EventRSVPList';
import RsvpPage from './pages/RsvpPage';
import Invitation from './pages/Invitation';
import Login from './pages/Login';
import Signup from './pages/Signup';
import SetPin from './pages/SetPin';
import Home from './pages/Home';
import { useAuth } from './context/AuthContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="app-wrapper" style={{ padding: '20px' }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="container">
        <nav>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h1 style={{ margin: 0, fontSize: '24px', background: '-webkit-linear-gradient(45deg, #6366f1, #ec4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Bhetcha RSVP
            </h1>
            <div style={{ marginLeft: '40px' }}>
              <Link to="/events">Events</Link>
            </div>
          </div>
          <div>
            {user ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <span style={{ color: '#6b7280' }}>Hi, {user.username || 'User'}</span>
                <button className="secondary" onClick={handleLogout} style={{ padding: '8px 16px', fontSize: '14px' }}>
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/login">
                <button style={{ padding: '8px 20px', fontSize: '14px' }}>Login</button>
              </Link>
            )}
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={
            <ProtectedRoute>
              <EventList />
            </ProtectedRoute>
          } />
          <Route path="/events/new" element={
            <ProtectedRoute>
              <CreateEvent />
            </ProtectedRoute>
          } />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/:id/rsvps" element={
            <ProtectedRoute>
              <EventRSVPList />
            </ProtectedRoute>
          } />
          <Route path="/rsvp/:token" element={<RsvpPage />} />
          <Route path="/invitation" element={<Invitation />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/set-pin/:token" element={<SetPin />} />
        </Routes>
      </div>
    </div>
  );
}
